var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/map",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 1.000000)",
    fill: "#616161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.625,6.0482 C5.701,6.0482 4.952,5.2992 4.952,4.3752 C4.952,3.4502 5.701,2.7012 6.625,2.7012 C7.549,2.7012 8.298,3.4502 8.298,4.3752 C8.298,5.2992 7.549,6.0482 6.625,6.0482 M6.625,0.0002 C4.209,0.0002 2.25,1.9592 2.25,4.3752 C2.25,6.9092 4.263,8.4932 5.352,10.3812 C6.394,12.1872 6.393,12.8812 6.625,12.8812 C6.857,12.8812 6.856,12.1872 7.898,10.3812 C8.987,8.4932 11,6.9092 11,4.3752 C11,1.9592 9.041,0.0002 6.625,0.0002",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.3158 L3,10.3158 L0,17.3158 L18,17.3158 L15,10.3158 Z M14.341,11.3158 L16.483,16.3158 L1.517,16.3158 L3.659,11.3158 L14.341,11.3158 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e27ac78e54084c796614d2746393e7d1.svg";
export { ForwardRef as ReactComponent };